const GotoList = (key, value) => {
    const url = "/sheetList"
    const param = key + "=" + encodeURI(value);
    window.location.href = url + "?" + param;
}

export { GotoList }